import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-executive",
  templateUrl: "./executive.component.html",
  styles: [],
})
export class ExecutiveComponent implements OnInit {
  userManagementData = {
    admin: false,
    title: "Últimos usuarios cargados",
    backUrl: "/pages/home/executive",
  };
  constructor() {}

  ngOnInit(): void {}
}
